import { Avatar } from '@optiro/ui';

import { useAccount } from '@/hooks/useAccount';
import { Account } from '@/types/types';

const UserAvatar = ({ userId, size = 32 }: { userId: Account['id']; size?: number }) => {
  const { data: user } = useAccount(userId);

  if (!user) {
    return null;
  }

  const hasPhoto = !user.photo.thumb.url.includes('fallback');

  return (
    <Avatar
      size={size}
      src={hasPhoto ? user.photo.thumb.url : null}
      name={user.name}
      color="initials"
    />
  );
};

export { UserAvatar };
